import { render, staticRenderFns } from "./SidePane.vue?vue&type=template&id=4b93903b&scoped=true"
import script from "./SidePane.vue?vue&type=script&lang=js"
export * from "./SidePane.vue?vue&type=script&lang=js"
import style0 from "./SidePane.vue?vue&type=style&index=0&id=4b93903b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93903b",
  null
  
)

export default component.exports